import { useEffect, useState } from "react";
import { getLoggedinUser } from "../../helpers/api_helper";

const resolveToken = (session: any): string | null => {
  if (!session) return null;
  return session.access_token || session.token || null;
};

const useProfile = () => {
  const userProfileSession = getLoggedinUser();
  var token = resolveToken(userProfileSession);
  const [loading, setLoading] = useState(userProfileSession ? false : true);
  const [userProfile, setUserProfile] = useState(
    userProfileSession ? userProfileSession : null
  );

  useEffect(() => {
    const session = getLoggedinUser();
    setUserProfile(session ? session : null);
    setLoading(resolveToken(session) ? false : true);
  }, []);

  return { userProfile, loading, token };
};

export { useProfile };
